import useChannel from './use-channel';

export { useChannel };
export default { useChannel };
